export enum HMSPollCategory {
  /**
   The poll is a standard poll.
   */
  poll,

  /**
   The poll is a quiz.
   */
  quiz,
}
